import common from '@/utils/'
import router from './router'
const whiteList = ['/login','/updatepwd']
router.beforeEach(async(to, from, next) => {
  const token=common.getToken();
  if(token){
    if(from.path){}
    if (to.path === '/login') {
      next({ path: '/' })
    }else{
      next()
    }
  }else{
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next('/login')
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js